import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PageHeadingWrapper from 'components/PageHeadingWrapper';
import TextLink from './TextLink';

const Wrapper = styled(PageHeadingWrapper)`
  h1 {
    text-transform: capitalize;
  }
  hr{
    display: block;
    margin: ${({ theme }) => theme.spacing * 2}px 0;
    width: 44px;
    border: none;
    border-top: 1px solid ${({ theme }) => theme.palette.grey[3]};
  }
  .TextLink{
    color: inherit;
    margin-bottom: ${({ theme }) => theme.spacing * 2}px;
  }
`;

const WelcomeWidget = ({ name, packageDetailsPath }) => (
  <Wrapper className="WelcomeWidget">
    <h1>{ !name || name.length > 11 ? 'Welcome' : `Hi ${name}`}</h1>
    <p>Manage your contact lens subscription</p>
    <hr />
    <TextLink rightChevron props={{ to: packageDetailsPath }}>See your package details</TextLink>
  </Wrapper>
);

WelcomeWidget.displayName = 'WelcomeWidget';

WelcomeWidget.propTypes = {
  name: PropTypes.string.isRequired,
  packageDetailsPath: PropTypes.string.isRequired,
};

export default WelcomeWidget;
